// Calendar-year cutoff for public batch listings — computed off the real
// clock, never a hardcoded year, so the listing rolls forward on its own
// every Jan 1.

/** Epoch ms of Jan 1, 00:00 (local time) of the current calendar year. */
export function getCurrentYearStart(reference: Date = new Date()): number {
  return new Date(reference.getFullYear(), 0, 1, 0, 0, 0, 0).getTime();
}

/** True if the given epoch ms timestamp falls in the current calendar year or later. */
export function isCurrentYearOrLater(timestamp: number): boolean {
  return timestamp >= getCurrentYearStart();
}
